module.exports = __webpack_public_path__ + "static/media/72.3ddd1636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/72.jpg
// module id = 1010
// module chunks = 0